import React from 'react';
import { useSelector } from 'react-redux';
import { ServiceRequestStatsTable } from '../../../../components/ReportingTable/ServiceRequestStatsTable';
import { ServiceRequestStats } from './Stats';

export const ServiceRequestStatsReport = () => {
  const report = useSelector((state) => state.serviceRequestStats);
  if (
    !report ||
    !report.serviceRequests ||
    report.serviceRequests.length === 0 ||
    !report.summary
  ) {
    return <></>;
  }

  console.log('report: ', report);

  return (
    <div>
      <h3>Service Request Stats</h3>
      <ServiceRequestStats data={report.summary} />
      <ServiceRequestStatsTable reports={report.serviceRequests} />
    </div>
  );
};
